import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { ServiceWorkerUpdateService } from './services/service-worker-update.service';
import { SmallLazyLoadingService } from './services/small-lazy-loading.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  @ViewChild('mainContainer', { read: ViewContainerRef, static: true }) mainContainerRef: any;

  constructor(private serviceWorkerUpdateService: ServiceWorkerUpdateService,
    private smallLazyLoadingService: SmallLazyLoadingService) {
  }

  ngOnInit() {
    this.smallLazyLoadingService.setMainContainerRef(this.mainContainerRef);
    if ((window.location.search).trim() !== '') {
      return this.smallLazyLoadingService.loadMainModule()
        .then(res => {
          this.removeLoadingNode();
        });
    }

    const theme: string = this.smallLazyLoadingService.read('pw-theme');
    if (theme) {
      this.smallLazyLoadingService.loadMainModule()
        .then(res => {
          this.removeLoadingNode();
        });
    } else {
      this.smallLazyLoadingService.loadVoiceSelection()
        .then(res => {
          this.removeLoadingNode();
        });
    }
    let appName = this.getAppName();
    if (appName == 'pw' || appName == 'android' || appName == 'ios') {
      this.serviceWorkerUpdateService.init();
    }
  }

  private getAppName() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf(' electron/') > -1) {
      return 'sw';
    }
    if (this.startWith(window.location + '', 'file')) {
      if (userAgent.indexOf('android') > -1) {
        return 'android';
      } else {
        return 'ios';
      }
    } else {
      return 'pw';
    }
  }

  public startWith(str, beginStr) {
    if (str.substr(0, beginStr.length) === beginStr) {
      return true;
    }
    return false;
  }

  private removeLoadingNode() {
    const appLoadingElem = document.getElementById('pw-loading');
    if (appLoadingElem != null) {
      appLoadingElem.parentNode.removeChild(appLoadingElem);
    }
  }
}
